import Head from 'next/head';
import { NextSeo } from 'next-seo';
import Offers from '@cont/Checkout/Offers/Offers';
import { fetchOfferList, fetchOfferFaqs } from '@actions/checkout';
import { redirectToRoute } from '@utils/route';
import { emptyList } from '@constants/empty';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const OffersPage = ({ goalInfo }) => {
  const { name = 'Unacademy', goalSlug, uid } = goalInfo || {};
  const metaTitle = `${name} Subscription Offers – Unacademy Exam Prep`;
  const metaDescription = `Grab exclusive ${name} subscription offers on Unacademy. Get extra free months on 15, 18 & 24-month exam preparation plans. Claim your offer today!`;
  const canonicalURL =
    goalSlug && uid
      ? `https://unacademy.com/goal/${goalSlug}/${uid}/offers`
      : null;

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical={canonicalURL}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          url: canonicalURL
        }}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <Offers />
    </>
  );
};

OffersPage.pageInfo = {
  isMWebSupported: true,
  name: 'Offers',
  layoutOptions: {
    showFixedHeader: true
  }
};

OffersPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, res }) => {
    const { goalUID, goalSlug } = query;

    await store.dispatch(fetchOfferList(goalUID));
    const offerList = store.getState().checkout.offerList[goalUID] || emptyList;
    const goalDetails = store.getState().topologies.data[goalUID.toUpperCase()];

    if (!offerList.length) {
      return redirectToRoute(
        isServer,
        res,
        '/goal/[goalSlug]/[goalUID]',
        `/goal/${goalDetails?.goalSlug || goalSlug}/${goalUID}`
      );
    }
    await store.dispatch(fetchOfferFaqs());
    return {
      goalInfo: goalDetails
    };
  },
  OffersPage.pageInfo
);

export default OffersPage;
OffersPage.Layout = Layout;
OffersPage.Wrapper = PageReduxProvider;
